/* eslint-disable quote-props */
const CONFIG = {
  BASE_URL: 'https://growfie-api.cyclic.app',
  headers: {
    'Authorization': process.env.API_KEY,
    'Content-Type': 'application/json',
  },
  CACHE_NAME: 'GrowthFamilie-V1',
};

export default CONFIG;